var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7874_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0.5C13.6944 0.500001 17.5 4.30558 17.5 9C17.5 13.6944 13.6944 17.5 9 17.5C4.30558 17.5 0.500001 13.6944 0.5 9C0.5 4.30558 4.30558 0.5 9 0.5Z",
    fill: "#FEF4F4",
    stroke: "#EE7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8474 11.1404C11.8951 11.1865 11.9332 11.2417 11.9594 11.3027C11.9856 11.3637 11.9994 11.4293 12 11.4957C12.0006 11.562 11.9879 11.6279 11.9628 11.6893C11.9376 11.7508 11.9005 11.8066 11.8536 11.8536C11.8066 11.9005 11.7508 11.9376 11.6893 11.9628C11.6279 11.9879 11.562 12.0006 11.4957 12C11.4293 11.9994 11.3637 11.9856 11.3027 11.9594C11.2417 11.9332 11.1865 11.8951 11.1404 11.8474L8.99386 9.70086L6.84736 11.8474C6.75305 11.9384 6.62675 11.9888 6.49566 11.9877C6.36456 11.9866 6.23915 11.934 6.14645 11.8413C6.05374 11.7486 6.00116 11.6232 6.00002 11.4921C5.99888 11.361 6.04928 11.2347 6.14036 11.1404L8.28686 8.99386L6.14036 6.84736C6.04928 6.75305 5.99888 6.62675 6.00002 6.49566C6.00116 6.36456 6.05374 6.23915 6.14645 6.14645C6.23915 6.05374 6.36456 6.00116 6.49566 6.00002C6.62675 5.99888 6.75305 6.04928 6.84736 6.14036L8.99386 8.28686L11.1404 6.14036C11.2347 6.04928 11.361 5.99888 11.4921 6.00002C11.6232 6.00116 11.7486 6.05374 11.8413 6.14645C11.934 6.23915 11.9866 6.36456 11.9877 6.49566C11.9888 6.62675 11.9384 6.75305 11.8474 6.84736L9.70086 8.99386L11.8474 11.1404Z",
    fill: "#EE7777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7874_270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCons);
export default __webpack_public_path__ + "static/media/cons.6c23b081a144bf5b589b7605cdeec694.svg";
export { ForwardRef as ReactComponent };